export default {"src":"/_next/static/media/pp-loading.1d8138a0.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};